import { useRef, useState } from "react";
import {useTranslation} from "react-i18next";
import emailjs from "@emailjs/browser";
import airplane from "../../../svg/airplane.png";
import LoadingDots from "../../components/LoadingDots";
import button1 from "../../../svg/button.png";

const SubmitProgramItem = (props) => {
  const [t, ] = useTranslation("global");
  const [count, setCount] = useState(0);
  const [bioCount, setBioCount] = useState(0);
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const form2 = useRef();

  let color = "white";
  let detailColor = "black";
  if (props.page === "academic") {
    color = "#12d7a6";
    detailColor = "#00ac9f";
  } else if (props.page === "school") {
    color = "#6832c7";
    detailColor = "#00ac9f";
  }

  const sendProgramEmail = (e) => {
    e.preventDefault();
    setLoading(true); 
    emailjs
      .sendForm(
        "service_v8sqigr",
        "template_i8n2y0c",
        form2.current,
        "kvvx_padstf0o02_b"
      )
      .then(
        (result) => {
          console.log(result.text);
          setLoading(false);
          setSubmitted(true);
        },
        (error) => {
          console.log(error.text);
          setLoading(false);
        }
      );
    e.target.reset();
  };

  let usersButton = {
    backgroundImage: `url(${button1})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    padding: "4px",
  };

  return (
      <>
        {props.page === "users" && (
          <div
              className="
                grid 
                grid-cols-1 
                lg:grid-cols-2 
                gap-12 
                justify-items-start 
                w-full
                px-4
                mx-auto
                lg:w-[65%]
                relative
              "
          >
            <div
              className="
                leftColumn 
                flex 
                flex-col 
                w-full
                relative
                "
              style={{width:'100%', textAlign:'left'}}
            >
              <div
                style={{ fontFamily: "Bebas Neue", color: color, width:'100%' }}
                className="text-5xl uppercase pb-6 text-left"
              >
                {t("home.submit-program-item")}
              </div>

              <div
                style={{ fontFamily: "Poppins" }}
                className="text-white text-justify text-left text-base"
              >
                {t("home.submit-program-player.text1")}
                <br /> <br />
                {t("home.submit-program-player.text2")}
                <br /> <br />
                <p className="font-bold text-2xl">
                  {t("home.submit-program-player.title2")} <br />
                </p>
                {t("home.submit-program-player.text3")} <br /> <br />
                
                <p className="font-bold text-2xl">
                  {t("home.submit-program-player.title3")} <br />
                </p>
                {t("home.submit-program-player.text4")} <br />
                <br />
                <p className="font-bold text-2xl">
                  {t("home.submit-program-player.title4")} <br />
                </p>
                <p className="font-bold">
                  {t("home.submit-program-player.title5")} <br />
                </p>
                {t("home.submit-program-player.text5")} <br /> <br />

                <p className="font-bold">
                  {t("home.submit-program-player.title6")} <br />
                </p>
                {t("home.submit-program-player.text6")} <br /> <br />

                <p className="font-bold">
                  {t("home.submit-program-player.title7")} <br />
                </p>
                {t("home.submit-program-player.text7")} <br /> <br />

                <p className="font-bold">
                  {t("home.submit-program-player.title8")} <br />
                </p>
                {t("home.submit-program-player.text8")} <br /> <br />
              </div>
            </div>

            <div
              className="
                rightColumn 
                flex 
                flex-col 
                items-center 
                lg:items-start
                w-full
              "
              style={{width:'100%'}}
            >
              <div
                style={{ fontFamily: "Bebas Neue", color: color }}
                className="text-4xl uppercase pb-6 pt-6 lg:pt-16 text-left"
              >
                {t("home.submit-form")}
              </div>
              {loading ? (
                  <div className="lg:w-3/5 sm:w-11/12 w-11/12 pt-0 lg:justify-self-end flex justify-center items-center">
                    <LoadingDots page="users" />
                  </div>
                ) : !submitted ? (
              <form
            ref={form2}
            onSubmit={sendProgramEmail}
            className="relative z-0 mb-3 group w-full"
          >
            <div className="relative z-0 w-full mb-3 group bg-lime-900/50">
              <input
                autoComplete="off"
                type="text"
                name="name"
                id="name"
                className="block  pl-10 py-4 px-0 w-full text-base text-lime-300 bg-transparent appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                placeholder=" "
                required
              />
              <label
                style={{ fontFamily: "Poppins" }}
                className="peer-focus:font-medium absolute text-base text-white italic pl-10 dark:text-gray-400 duration-300 transform -translate-y-5 scale-75 top-5 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-lime-200 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-5"
              >
                {t("home.name-player")}
              </label>
            </div>
            <div className="relative z-0 w-full mb-3 group bg-lime-900/50">
              <input
                autoComplete="off"
                type="email"
                name="email"
                id="email"
                className="block pl-10 py-4 px-0 w-full text-base text-lime-300 bg-transparent appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                placeholder=" "
                required
              />
              <label
                style={{ fontFamily: "Poppins" }}
                className="peer-focus:font-medium absolute text-base text-white italic pl-10  dark:text-gray-400 duration-300 transform -translate-y-5 scale-75 top-5 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-lime-200 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-5"
              >
                {t("home.e-mail-player")}
              </label>
            </div>
            <div className="relative z-0 w-full mb-3 group bg-lime-900/50">
              <input
                autoComplete="off"
                type="text"
                name="subject"
                id="subject"
                className="block pl-10 py-4 px-0 w-full text-base text-lime-300 bg-transparent appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                placeholder=" "
                required
              />
              <label
                style={{ fontFamily: "Poppins" }}
                className="peer-focus:font-medium absolute text-base text-white italic pl-10  dark:text-gray-400 duration-300 transform -translate-y-5 scale-75 top-5 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-lime-200 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-5"
              >
                {t("home.subject-player")}
              </label>
            </div>
            <div className="relative z-0 w-full mb-3 group bg-lime-900/50 pr-2">
              <select
                autoComplete="off"
                type="text"
                name="type"
                id="type"
                className="px-10 outline-pink-900 focus:outline-none italic focus:ring-lime-500 block py-4 px-0 w-full text-base text-white bg-transparent  dark:text-white dark:border-lime-200 focus:bg-lime-700 dark:focus:border-lime-200 focus:outline-none focus:ring-0 focus:border-lime-200 peer"
                placeholder=" "
                required
              >
                <option
                  style={{ fontFamily: "Poppins" }}
                  className="bg-lime-900"
                  default
                >
                  {t("home.type")}
                </option>
                <option
                  style={{ fontFamily: "Poppins" }}
                  className="bg-lime-900"
                >
                  {t("home.type-forms.lecture")}
                </option>
                <option
                  style={{ fontFamily: "Poppins" }}
                  className="bg-lime-900"
                >
                  {t("home.type-forms.workshop")}
                </option>
                <option
                  style={{ fontFamily: "Poppins" }}
                  className="bg-lime-900"
                >
                  {t("home.type-forms.discution-panel")}
                </option>
                                <option
                  style={{ fontFamily: "Poppins" }}
                  className="bg-lime-900"
                >
                  {t("home.type-forms.other-format")}
                </option>
              </select>
            </div>
            <div className="flex items-stretch  relative z-0 w-full h-52 group bg-lime-900/50">
              <textarea
                maxLength="2000"
                autoComplete="off"
                type="text"
                name="message"
                id="message"
                className="block resize-none pl-10 py-4 px-0 w-full text-base text-lime-300 bg-transparent appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                placeholder=" "
                required
                onChange={(e) => setCount(e.target.value.length)}
              />
              <label
                style={{ fontFamily: "Poppins" }}
                className="peer-focus:font-medium absolute text-base text-white italic pl-10  dark:text-gray-400 duration-300 transform -translate-y-5 scale-75 top-5 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-lime-200 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-5"
              >
                {t("home.write-abstract-player")}
              </label>
              <div
                style={{ fontFamily: "Poppins" }}
                className="self-end w-32 pr-2 pb-2 italic text-base text-white"
              >
                {count} / 2000
              </div>
            </div>
            <div className="text-center mx-auto">
              <button
                className="text-white w-48 h-20 text-center uppercase text-xl mt-4"
                style={{...usersButton, width:"200px", height:"60px"}}
              >
                {t("home.submit")}
              </button>
            </div>
              </form> ) : (
                <div className="w-full pt-0 lg:justify-self-start text-white text-3xl text-center pt-12 pb-12" style={{ width:'100%', fontFamily:"Bebas Neue", backgroundColor:"#1b2a0a" }}>
                  {t("home.thank-you-form")}
                </div>
              )}
            </div>
          </div>
        )}
        {props.page === "school" && (
          <div
              className="
                grid 
                grid-cols-1 
                lg:grid-cols-2 
                gap-12 
                justify-items-center 
                w-full
                px-4
                mx-auto
                lg:w-[65%]
                relative
              "
          >
            <div
              className="
                leftColumn 
                flex 
                flex-col 
                items-center 
                lg:items-start
                w-full
                relative
                "
              style={{width:'100%'}}
            >
              <div
                style={{ fontFamily: "Bebas Neue", color: color, width:'100%' }}
                className="text-5xl uppercase pb-6 text-center lg:text-left"
              >
                {t("home.submit-program-item")}
              </div>

              <div
                style={{ fontFamily: "Poppins", textAlignLast: "left", width:'100%' }}
                className="
                  text-black 
                  text-justify 
                  text-base
                "
              >
                {t("home.submit-program-school.text1")}
                <br /><br />
                {t("home.submit-program-school.text2")}
                <br /><br />

                <p className="font-bold text-2xl uppercase" style={{ color: color, textAlign:'left' }}>
                  {t("home.submit-program-school.title2")}
                </p>
                {t("home.submit-program-school.text3")}
                <br /><br />

                <p className="font-bold text-2xl uppercase" style={{ color: color }}>
                  {t("home.submit-program-school.title3")}
                </p>
                {t("home.submit-program-school.text4")}
                <br /><br />

                <p className="font-bold text-2xl" style={{ color: color }}>
                  {t("home.submit-program-school.title4")}
                </p>
                <p className="font-bold" style={{ color: color }}>
                  {t("home.submit-program-school.title5")}
                </p>
                {t("home.submit-program-school.text5")}
                <br /><br />

                <p className="font-bold" style={{ color: color }}>
                  {t("home.submit-program-school.title6")}
                </p>
                {t("home.submit-program-school.text6")}
                <br /><br />

                <p className="font-bold" style={{ color: color }}>
                  {t("home.submit-program-school.title7")}
                </p>
                {t("home.submit-program-school.text7")}
                <br /><br />

                <p className="font-bold" style={{ color: color }}>
                  {t("home.submit-program-school.title8")}
                </p>
                {t("home.submit-program-school.text8")}
                <br /><br />
              </div>

              <img
                src={airplane}
                alt="decorative"
                className="absolute -bottom-[15%] left-0 max-w-[40%] sm:max-w-[30%] md:max-w-[25%] lg:max-w-[20%] opacity-30 z-0"
                style={{ objectFit: "contain" }}
              />
            </div>

            <div
              className="
                rightColumn 
                flex 
                flex-col 
                items-center 
                lg:items-start
                w-full
              "
              style={{width:'100%'}}
            >
              <div
                style={{ fontFamily: "Bebas Neue", color: color }}
                className="text-4xl uppercase pb-6 pt-6 lg:pt-16 text-center lg:text-left"
              >
                {t("home.submit-form")}
              </div>
              {loading ? (
                  <div className="lg:w-3/5 sm:w-11/12 w-11/12 pt-0 lg:justify-self-end flex justify-center items-center">
                    <LoadingDots page="submit-school" />
                  </div>
              ) : !submitted ? (
              <form
        ref={form2}
        onSubmit={sendProgramEmail}
        className="relative z-0 w-full mb-3 group"
      >
                <div className="relative z-0 w-full mb-3 group">
                  <input
                    autoComplete="off"
                    type="text"
                    name="name"
                    id="name"
                    className="block  pl-10 py-4 px-0 w-full text-base text-lime-300 bg-transparent appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                    placeholder=" "
                    required
                    style={{ border: `1px solid ${color}`, borderRadius: "25px", color: detailColor}}
                  />
                  <label
                    style={{ fontFamily: "Poppins", color: detailColor}}
                    className="peer-focus:font-medium absolute text-base text-white italic pl-10 dark:text-gray-400 duration-300 transform -translate-y-5 scale-75 top-5 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-lime-200 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-5"
                  >
                    {t("home.name-player")}
                  </label>
                </div>
                <div className="relative z-0 w-full mb-3 group">
                  <input
                    autoComplete="off"
                    type="email"
                    name="email"
                    id="email"
                    className="block pl-10 py-4 px-0 w-full text-base text-lime-300 bg-transparent appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                    placeholder=" "
                    style={{ border: `1px solid ${color}`, borderRadius: "25px", color: detailColor}}
                    required
                  />
                  <label
                    style={{ fontFamily: "Poppins", color: detailColor }}
                    className="peer-focus:font-medium absolute text-base text-white italic pl-10  dark:text-gray-400 duration-300 transform -translate-y-5 scale-75 top-5 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-lime-200 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-5"
                  >
                    {t("home.e-mail-player")}
                  </label>
                </div>
                <div className="relative z-0 w-full mb-3 group">
                  <input
                    autoComplete="off"
                    type="text"
                    name="subject"
                    id="subject"
                    className="block pl-10 py-4 px-0 w-full text-base text-lime-300 bg-transparent appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                    placeholder=" "
                    style={{ border: `1px solid ${color}`, borderRadius: "25px", color: detailColor }}
                    required
                  />
                  <label
                    style={{ fontFamily: "Poppins", color: detailColor }}
                    className="peer-focus:font-medium absolute text-base text-white italic pl-10  dark:text-gray-400 duration-300 transform -translate-y-5 scale-75 top-5 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-lime-200 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-5"
                  >
                    {t("home.subject-player")}
                  </label>
                </div>
                <div className="relative z-0 w-full mb-3 group">
                  <select
                    autoComplete="off"
                    name="type"
                    id="type"
                    className="outline-none italic block py-4 pl-10 pr-14 w-full text-base bg-transparent text-white
                              focus:ring-0 focus:border-lime-200
                              dark:text-white dark:border-lime-200"
                    style={{
                      border: `1px solid ${color}`,
                      borderRadius: "25px",
                      color: detailColor,
                      appearance: "none",           // <— important
                      WebkitAppearance: "none",     // <— Safari
                      MozAppearance: "none"         // <— Firefox
                    }}
                    required
                  >
                    <option
                      style={{ fontFamily: "Poppins", color: detailColor, }}
                      default
                    >
                      {t("home.type")}
                    </option>
                    <option
                      style={{ fontFamily: "Poppins", color: detailColor }}
                    >
                      {t("home.type-forms.lecture")}
                    </option>
                    <option
                      style={{ fontFamily: "Poppins", color: detailColor }}
                    >
                      {t("home.type-forms.workshop")}
                    </option>
                    <option
                      style={{ fontFamily: "Poppins", color: detailColor }}
                    >
                      {t("home.type-forms.discution-panel")}
                    </option>
                    <option
                      style={{ fontFamily: "Poppins", color: detailColor }}
                    >
                      {t("home.type-forms.other-format")}
                    </option>
                  </select>
                  <div
                    className="pointer-events-none absolute top-1/2 -translate-y-1/2 text-white"
                    style={{ right: "1.5rem", color: detailColor }}
                  >
                    ˅
                  </div>
                </div>
                <div className="flex items-stretch relative z-0 w-full h-[26rem]" style={{ width:"100%" }}>
                  <textarea
                    maxLength="2000"
                    autoComplete="off"
                    type="text"
                    name="message"
                    id="message"
                    className="block resize-none w-full px-10 py-4 text-base text-lime-300 bg-transparent appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                    placeholder=" "
                    style={{ border: `1px solid ${color}`, borderRadius: "25px", color: detailColor}}
                    required
                    onChange={(e) => setCount(e.target.value.length)}
                  />
                  <div
                    className="absolute bottom-2 right-4 italic text-base text-white"
                    style={{ fontFamily: "Poppins", color: detailColor}}
                  >
                    {count} / 2000
                  </div>
                  <label
                    style={{ fontFamily: "Poppins", color: detailColor }}
                    className="peer-focus:font-medium absolute text-base text-white italic pl-10  dark:text-gray-400 duration-300 transform -translate-y-5 scale-75 top-5 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-lime-200 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-5"
                  >
                    {t("home.write-abstract-player")}
                  </label>
                </div>
                <div className="relative z-0 w-full group">
                  <button
                    id="tickets"
                    className="text-white text-xl hover:bg-lime-500 focus:ring-4 focus:outline-none focus:bg-lime-900 font-medium text-base w-full px-5 py-4 mt-4 text-center"
                    style={{backgroundColor: detailColor, borderRadius: "25px", }}
                  >
                    {t("home.submit")}
                  </button>
                </div>
              </form> ) : (
                <div className="w-full pt-0 lg:justify-self-start text-white text-3xl text-center pt-12 pb-12" style={{ width:'100%', fontFamily:"Bebas Neue", backgroundColor:"#6932c7ff" }}>
                  {t("home.thank-you-form")}
                </div>
              )}
            </div>
          </div>
        )}
        {props.page === "academic" && (
          <div
              className="
                grid 
                grid-cols-1 
                lg:grid-cols-2 
                gap-12
                w-full
                px-4
                mx-auto
                lg:w-[65%]
                relative
              "
          >
            <div
              className="
                leftColumn 
                flex 
                flex-col 
                w-full
                relative
                "
              style={{width:'100%', textAlign:'justify'}}
            >
              <div
                style={{ fontFamily: "Bebas Neue", color: color, width:'100%' }}
                className="text-5xl uppercase pb-6 text-left"
              >
                {t("home.submit-program-item")}
              </div>
              <div
                style={{ fontFamily: "Poppins" }}
                className="text-black text-base px-2"
              >
                {t("home.submit-program-academic.text1")}
                <br /> 
                {t("home.submit-program-academic.text2")}
                <br /> <br />
                <ul className="ml-8">
                  <li>• {t("home.submit-program-academic.list1")}</li>
                  <li>• {t("home.submit-program-academic.list2")}</li>
                </ul>
                <br /> 
                {t("home.submit-program-academic.text3")}
                <br /><br /> 
                {t("home.submit-program-academic.text4")}
                <br /><br /> 
                <p className="font-bold" style={{color:'#12d7a6'}}>
                  {t("home.submit-program-academic.title2")}
                </p>
                {t("home.submit-program-academic.text5")}
                <br/><br/> 
                <ul className="ml-8">
                  <li>• {t("home.submit-program-academic.list4")}</li>
                  <li>• {t("home.submit-program-academic.list5")}</li>
                  <li>• {t("home.submit-program-academic.list6")}</li>
                  <li>• {t("home.submit-program-academic.list7")}</li>
                  <li>• {t("home.submit-program-academic.list8")}</li>
                </ul>
                <br />
                <p className="font-bold" style={{color:'#12d7a6'}}>
                  {t("home.submit-program-academic.title3")}
                </p>
                <ul className="ml-8">
                  <li>• {t("home.submit-program-academic.list9")}</li>
                  <li>• {t("home.submit-program-academic.list10")}</li>
                  <li>• {t("home.submit-program-academic.list11")}</li>
                  <li>• {t("home.submit-program-academic.list12")}</li>
                </ul>
                <br /> 
                {t("home.submit-program-academic.text7")}
                <br /> <br />
                <p className="font-bold" style={{color:'#12d7a6'}}>
                  {t("home.submit-program-academic.title4")}
                </p>
                <br />
                {t("home.submit-program-academic.text8")}
              </div>
            </div>
            <div
              className="
                rightColumn 
                flex 
                flex-col 
                items-center 
                lg:items-start
                w-full
              "
              style={{width:'100%'}}
            >
              <div
                style={{ fontFamily: "Bebas Neue", color: color }}
                className="text-4xl uppercase pt-6 lg:pt-16 text-left"
              >
                {t("home.submit-form")}
              </div>
            {loading ? (
                  <div className="lg:w-3/5 sm:w-11/12 w-11/12 pt-0 lg:justify-self-end flex justify-center items-center">
                    <LoadingDots page="submit-academic" />
                  </div>
            ) : !submitted ? (
            <form
            ref={form2}
            onSubmit={sendProgramEmail}
            className="relative w-full"

          >
            <div className="relative z-0 w-full mb-3 group bg-white border-2 border-green-white" >
              <input
                autoComplete="off"
                type="text"
                name="name"
                id="name"
                className="block pl-10 py-4 px-0 w-full text-base text-black bg-transparent appearance-none dark:text-green-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                placeholder=" "
                required
              />
              <label className="peer-focus:font-medium absolute text-base text-green-white italic pl-10 dark:text-gray-400 duration-300 transform -translate-y-5 scale-75 top-5 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-black peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-5">
                {t("home.name")}
              </label>
            </div>
            <div className="relative z-0 w-full mb-3 group border-2 border-green-white bg-white">
              <input
                autoComplete="off"
                type="email"
                name="email"
                id="email"
                className="block pl-10 py-4 px-0 w-full text-base text-black bg-transparent appearance-none dark:text-green-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                placeholder=" "
                required
              />
              <label className="peer-focus:font-medium absolute text-base text-green-white italic pl-10  dark:text-gray-400 duration-300 transform -translate-y-5 scale-75 top-5 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-black peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-5">
                {t("home.e-mail")}
              </label>
            </div>
            <div className="relative z-0 w-full mb-3 group border-2 border-green-white bg-white">
              <input
                autoComplete="off"
                type="text"
                name="subject"
                id="subject"
                className="block pl-10 py-4 px-0 w-full text-base text-black bg-transparent appearance-none dark:text-green-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                placeholder=" "
                required
              />
              <label className="peer-focus:font-medium absolute text-base text-green-white italic pl-10  dark:text-gray-400 duration-300 transform -translate-y-5 scale-75 top-5 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-black peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-5">
                {t("home.subject")}
              </label>
            </div>
            <div className="relative z-0  w-full mb-3 group border-2 border-green-white bg-white pr-2">
              <select
                autoComplete="off"
                type="text"
                name="type"
                id="type"
                className="px-10 focus:outline-none italic focus:ring-lime-500 block py-4 px-0 w-full text-base text-green-white bg-transparent  dark:text-green-white dark:border-black focus:bg-white dark:focus:border-black focus:outline-none focus:ring-0 focus:border-black peer"
                placeholder=" "
                required
              >
                <option className="bg-white" default>
                  {t("home.type")}
                </option>
                <option className="bg-white">
                  {t("home.academic-type-forms.academic-paper")}
                </option>
                <option className="bg-white">
                  {t("home.academic-type-forms.poster")}
                </option>
              </select>
            </div>
            <div className="flex items-stretch relative z-0 w-full h-24 mb-3 group border-2 border-green-white bg-white">
              <textarea
                maxLength="500"
                autoComplete="off"
                type="text"
                name="shortBio"
                id="shortBio"
                className="block resize-none pl-10 py-4 px-0 w-full text-base text-black bg-transparent appearance-none dark:text-green-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                placeholder=" "
                required
                onChange={(e) => setBioCount(e.target.value.length)}
              ></textarea>

              <label className="peer-focus:font-medium absolute text-base text-green-white italic pl-10  dark:text-gray-400 duration-300 transform -translate-y-5 scale-75 top-5 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-black peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-5">
                {t("home.write-bio")}
              </label>
              <label className="self-end w-32 pr-2 pb-2 italic text-base text-green-white">
                {bioCount} / 500
              </label>
            </div>
            <div className="flex items-stretch relative z-0 w-full h-52 mb-3 group border-2 border-green-white bg-white">
              <textarea
                maxLength="2000"
                autoComplete="off"
                type="text"
                name="message"
                id="message"
                className="block resize-none pl-10 py-4 px-0 w-full text-base text-black bg-transparent appearance-none dark:text-green-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                placeholder=" "
                required
                onChange={(e) => setCount(e.target.value.length)}
              ></textarea>

              <label className="peer-focus:font-medium absolute text-base text-green-white italic pl-10  dark:text-gray-400 duration-300 transform -translate-y-5 scale-75 top-5 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-black peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-5">
                {t("home.write-abstract")}
              </label>
              <label className="self-end w-32 pr-2 pb-2 italic text-base text-green-white">
                {count} / 2000
              </label>
            </div>
            <div className="relative w-full  group border-2 border-green-white -mt-3">
              <button
                id="tickets"
                type="submit"
                value="Send"
                className="text-white bg-gradient-to-r from-green-white to-green-dark hover:bg-green-dark focus:ring-4 focus:outline-none focus:bg-lime-900 font-medium text-xl w-full px-5 py-4 text-center"
              >
                {t("home.submit")}
              </button>
            </div>
            </form> ) : (
                <div className="w-full pt-0 lg:justify-self-start text-white text-3xl text-center pt-12 pb-12" style={{ width:'100%', fontFamily:"Bebas Neue", backgroundColor:"#097d75" }}>
                  {t("home.thank-you-form")}
                </div>
              )}
            </div>
          </div>
        )}
      </>
  );
};

export default SubmitProgramItem;
